import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-cm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationDetailsCmConstants } from "./view-application-details-cm.constants";
import { ViewApplicationDeceasedCmConstants } from "../view-application-deceased-cm/view-application-deceased-cm.constants";
import { ViewApplicationService } from "../../../view-application.service";
import { DatePipe } from "@angular/common";
import { AlertType } from "../../../../../shared/models/alert";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { CemeteryService } from "../../../../../shared/services/modules/cemetery.service";
import { forkJoin } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { GraveSearchService } from "src/app/tabs/graves/shared/services/grave-search.service";
import { SettingsService } from "src/app/core/settings/settings.service";
import Query from "@arcgis/core/rest/support/Query";
import { MapService } from "src/app/map/shared/map.service";
import { MapServiceService } from "src/app/core/settings/shared/map-service.service";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { StepMetadataConstants } from "../../../../../core/settings/components/step-metadata/step-metadata.constants";
let ViewApplicationDetailsCmComponent = class ViewApplicationDetailsCmComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    settingsService;
    mapService;
    mapServiceService;
    graveSearchService;
    viewApplicationService;
    recipientSelectService;
    appController;
    requestStatusService;
    cemeteryService;
    datePipe;
    changeDetectorRefs;
    detailsForm;
    validationMessages = ViewApplicationDetailsCmConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionFormControlName = ViewApplicationDetailsCmConstants.DESCRIPTION_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsCmConstants.REFERENCE_NUMBER_FORM_CONTROL_NAME;
    burialTypeFormControlName = ViewApplicationDetailsCmConstants.BURIAL_TYPE_FORM_CONTROL_NAME;
    burialDateFormControlName = ViewApplicationDetailsCmConstants.BURIAL_DATE_FORM_CONTROL_NAME;
    funeralParlourFormControlName = ViewApplicationDetailsCmConstants.FUNERAL_PARLOUR_FORM_CONTROL_NAME;
    pauperDecisionControlName = ViewApplicationDetailsCmConstants.PAUPER_DECISION_FORM_CONTROL_NAME;
    pauperDecisionDateControlName = ViewApplicationDetailsCmConstants.PAUPER_DECISION_DATE_FORM_CONTROL_NAME;
    isDocumentationCompleteControlName = ViewApplicationDetailsCmConstants.IS_DOCUMENTATION_COMPLETE_FORM_CONTROL_NAME;
    cemeteryFormControlName = ViewApplicationDetailsCmConstants.CEMETERY_FORM_CONTROL_NAME;
    descriptionLabel = ViewApplicationDetailsCmConstants.DESCRIPTION_LABEL;
    burialTypeLabel = ViewApplicationDetailsCmConstants.BURIAL_TYPE_LABEL;
    burialDateLabel = ViewApplicationDetailsCmConstants.BURIAL_DATE_LABEL;
    referenceNumberLabel = ViewApplicationDetailsCmConstants.REFERENCE_NUMBER_LABEL;
    pauperDecisionLabel = ViewApplicationDetailsCmConstants.PAUPER_DECISION_LABEL;
    pauperDecisionDateLabel = ViewApplicationDetailsCmConstants.PAUPER_DECISION_DATE_LABEL;
    isDocumentationCompleteLabel = ViewApplicationDetailsCmConstants.IS_DOCUMENTATION_COMPLETE_LABEL;
    cemeteryLabel = ViewApplicationDetailsCmConstants.CEMETERY_LABEL;
    funeralParlourDisableFilterBy = false;
    funeralParlourDisableAdd = false;
    funeralParlourDisableEditing = false;
    funeralParlourShowFields = true;
    funeralParlourIsInternal = false;
    funeralParlourGroups = [];
    funeralParlourLabel = ViewApplicationDetailsCmConstants.FUNERAL_PARLOUR_LABEL;
    applicationTypes = [];
    defaultGraveStatus = [];
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    application;
    getApplicationSaveDetailsObservableSubscription;
    getStepMetaObservableSubscription;
    getLayerDataBySelectionLayerTypeSubscription;
    cemeteries = [];
    cemeteryServiceUrl;
    defaultCemetery = {
        cemeteryName: ViewApplicationDetailsCmConstants.DEFAULT_CEMETERY_NAME,
        cemeteryId: null,
        cemeteryObjectId: null
    };
    constructor(aflaModuleStrategyService, route, routerParamsService, settingsService, mapService, mapServiceService, graveSearchService, viewApplicationService, recipientSelectService, appController, requestStatusService, cemeteryService, datePipe, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.settingsService = settingsService;
        this.mapService = mapService;
        this.mapServiceService = mapServiceService;
        this.graveSearchService = graveSearchService;
        this.viewApplicationService = viewApplicationService;
        this.recipientSelectService = recipientSelectService;
        this.appController = appController;
        this.requestStatusService = requestStatusService;
        this.cemeteryService = cemeteryService;
        this.datePipe = datePipe;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    loadMetadata(stepMeta) {
        this.funeralParlourGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.funeralParlourGroup);
        this.changeDetectorRefs.detectChanges();
        this.getLookups();
        if (this.aflaModuleStrategyService.lookups.has("applicationTypes") &&
            this.aflaModuleStrategyService.lookups.has("defaultGraveStatus") &&
            this.aflaModuleStrategyService.lookups.has("cemeteries")) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
            this.defaultGraveStatus = this.aflaModuleStrategyService.lookups.get("defaultGraveStatus");
            this.cemeteries = this.aflaModuleStrategyService.lookups.get("cemeteries");
            this.getCemeteries();
        }
        else {
            this.getLookups();
        }
    }
    getCemeteries() {
        this.requestStatusService.showBusySpinner("Getting cemeteries");
        this.viewApplicationService.getModuleMaps(+this.appController.selectedModuleID).pipe(take(1)).subscribe({
            next: (moduleMapsResult) => {
                const moduleMaps = moduleMapsResult.value;
                let cemeteryModuleMap = null;
                let graveModuleMap = null;
                for (const moduleMap of moduleMaps) {
                    if (moduleMap.selectionLayerType === "Cemetery") {
                        cemeteryModuleMap = moduleMap;
                    }
                    if (moduleMap.selectionLayerType === "Grave") {
                        graveModuleMap = moduleMap;
                    }
                }
                if (cemeteryModuleMap !== null && graveModuleMap !== null) {
                    const gravesIds = this.defaultGraveStatus.map(item => `GraveStatus='${item.value}'`);
                    const gravesQueryWhere = gravesIds.join(" or ");
                    const gravesQueryReturnGeometry = false;
                    const gravesQueryOutFields = "CemeteryID";
                    const gravesQueryReturnDistinctValues = true;
                    const cemeteryQueryWhere = `1=1`;
                    const cemeteryQueryReturnGeometry = false;
                    const cemeteryQueryOutFields = "*";
                    const proxyUrl = ApiProxyConstants.URL;
                    let graveQueryUrl = "";
                    if (graveModuleMap.url.endsWith("/")) {
                        graveQueryUrl = "query";
                    }
                    else {
                        graveQueryUrl = "/query";
                    }
                    const graveUrl = `${graveModuleMap.url}${graveQueryUrl}?where=${gravesQueryWhere}&returnGeometry=${gravesQueryReturnGeometry}&outFields=${gravesQueryOutFields}&returnDistinctValues=${gravesQueryReturnDistinctValues}&f=json`;
                    let cemeteryQueryUrl = "";
                    if (cemeteryModuleMap.url.endsWith("/")) {
                        cemeteryQueryUrl = "query";
                    }
                    else {
                        cemeteryQueryUrl = "/query";
                    }
                    const cemeteryUrl = `${cemeteryModuleMap.url}${cemeteryQueryUrl}?where=${cemeteryQueryWhere}&returnGeometry=${cemeteryQueryReturnGeometry}&outFields=${cemeteryQueryOutFields}&f=json`;
                    const proxyGavesUrl = `${proxyUrl}?${encodeURIComponent(graveUrl)}`;
                    const proxyCemeteryUrl = `${proxyUrl}?${encodeURIComponent(cemeteryUrl)}`;
                    forkJoin([this.viewApplicationService.queryMapViaProxy(proxyCemeteryUrl, cemeteryModuleMap.id),
                        this.viewApplicationService.queryMapViaProxy(proxyGavesUrl, graveModuleMap.id)])
                        .pipe(take(1))
                        .subscribe({
                        next: data => {
                            const cemeteryFeatureSet = data[0];
                            const gravesFeatureSet = data[1];
                            if (gravesFeatureSet?.features?.length > 0) {
                                const gravesIds = gravesFeatureSet.features.map(item => this.propertyDataAlternateColumnName(item.attributes, "CemeteryID", "cemeteryid"));
                                if (cemeteryFeatureSet?.features?.length > 0) {
                                    const filteredCemeteries = cemeteryFeatureSet.features
                                        .map(item => ({
                                        cemeteryName: this.propertyDataAlternateColumnName(item.attributes, "Name", "name"),
                                        cemeteryId: this.propertyDataAlternateColumnName(item.attributes, "OBJECTID", "objectid"),
                                        cemeteryObjectId: null
                                    }))
                                        .filter(cemetery => gravesIds.includes(cemetery.cemeteryId));
                                    this.cemeteries = [
                                        this.defaultCemetery,
                                        ...filteredCemeteries
                                    ];
                                    this.cemeteries = [
                                        this.cemeteries[0],
                                        ...this.cemeteries.slice(1).sort((a, b) => a?.cemeteryName?.localeCompare(b?.cemeteryName))
                                    ];
                                    this.aflaModuleStrategyService.lookups.set("cemeteries", this.cemeteries);
                                    this.detailsForm.get(this.cemeteryFormControlName).setValue(this.defaultCemetery);
                                    this.changeDetectorRefs.detectChanges();
                                }
                            }
                            this.getApplication();
                            this.requestStatusService.removeBusySpinner("Getting cemeteries");
                        },
                        error: error => {
                            this.getApplication();
                            this.requestStatusService.removeBusySpinner("Getting cemeteries");
                            this.appController.handleServerErrorMessage(StepMetadataConstants.STEP_TITLE, error, CRUDOperation.Get);
                        }
                    });
                }
                else {
                    this.getApplication();
                    this.requestStatusService.removeBusySpinner("Getting cemeteries");
                }
            },
            error: (error) => {
                this.getApplication();
                this.requestStatusService.removeBusySpinner("Getting cemeteries");
                this.appController.handleServerErrorMessage(ViewApplicationDetailsCmConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    onBtnSaveClicked($event) {
        if (this.detailsForm.valid) {
            const funeralParlourFormValue = this.detailsForm.get("funeralParlour").value;
            const funeralParlour = RecipientUtils.removeRecipientProperties(funeralParlourFormValue);
            const params = {
                burialDate: this.detailsForm.get(this.burialDateFormControlName).value,
                cemeteryId: this.detailsForm.get(this.cemeteryFormControlName).value.cemeteryId,
                cemeteryName: this.detailsForm.get(this.cemeteryFormControlName).value.cemeteryName,
                type: this.detailsForm.get(this.burialTypeFormControlName).value.value,
                funeralParlour
            };
            this.getApplicationSaveDetailsObservableSubscription =
                this.cemeteryService.getApplicationSaveDetailsObservable(this.application.id, params)
                    .subscribe({
                    next: (appSaveresponse) => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        this.getApplication();
                    }, error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationDetailsCmConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getApplication() {
        const params = {
            $expand: `funeralParlour($expand=groups)`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsCmConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    handleRouteChange() {
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    getCemandGraveLayers(flCemetery, flGraves) {
        const cemeteryQuery = new Query();
        cemeteryQuery.where = `1=1`;
        cemeteryQuery.returnGeometry = false;
        cemeteryQuery.outFields = ["*"];
        const gravesQuery = new Query();
        gravesQuery.where = `GraveStatus = 'Available'`;
        gravesQuery.returnGeometry = false;
        gravesQuery.outFields = ["CemeteryID"];
        gravesQuery.returnDistinctValues = true;
        flGraves.queryFeatures(gravesQuery).then(graveResult => {
            const cemeteryIdsWithAvailableGraves = graveResult.features.map(f => f.attributes["CemeteryID"]);
            flCemetery.queryFeatures(cemeteryQuery).then(cemeteryResult => {
                cemeteryResult.features.forEach(feature => {
                    const cemeteryId = feature.attributes["CemeteryID"];
                    if (cemeteryIdsWithAvailableGraves.includes(cemeteryId)) {
                        this.cemeteries.push({
                            cemeteryName: feature.attributes["Name"],
                            cemeteryId,
                            cemeteryObjectId: feature.attributes["OBJECTID"]
                        });
                    }
                });
                this.changeDetectorRefs.detectChanges();
            });
        });
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
        this.mapService.getLayerDataBySelectionLayerTypeModuleId(Number(this.moduleID), "Cemetery").pipe(take(1)).subscribe(cemetery => {
            const flCemetery = new FeatureLayer();
            flCemetery.url = cemetery.url;
            flCemetery.visible = false;
            flCemetery.title = "Cemetery";
            this.mapService.getLayerDataBySelectionLayerTypeModuleId(Number(this.moduleID), "Grave").pipe(take(1)).subscribe(grave => {
                const flGraves = new FeatureLayer();
                flGraves.url = grave.url;
                flGraves.visible = false;
                flGraves.title = "Grave";
                this.getCemandGraveLayers(flCemetery, flGraves);
            });
        });
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID} and (name eq 'ApplicationType' or name eq 'DefaultGraveStatus')`,
        };
        this.viewApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDeceasedCmConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const defaultGraveStatus = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === "DefaultGraveStatus") {
                    defaultGraveStatus.push(JSON.parse(item.content));
                }
            });
        }
        applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
        defaultGraveStatus.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.aflaModuleStrategyService.lookups.set("defaultGraveStatus", defaultGraveStatus);
        this.applicationTypes = applicationTypes;
        this.defaultGraveStatus = defaultGraveStatus;
        this.getCemeteries();
        this.changeDetectorRefs.detectChanges();
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.application = response.value[0];
            this.detailsForm.get(this.descriptionFormControlName).setValue(this.application.description);
            this.detailsForm.get(this.referenceNumberControlName).setValue(this.application.referenceNumber);
            this.detailsForm.get(this.burialDateFormControlName).setValue(this.datePipe.transform(this.application.burialDate, "yyyy-MM-dd"));
            this.detailsForm.get(this.pauperDecisionControlName).setValue(this.application.pauperDecision);
            this.detailsForm.get(this.pauperDecisionDateControlName).setValue(this.datePipe.transform(this.application.pauperDecisionDate, "yyyy-MM-dd"));
            this.detailsForm.get(this.isDocumentationCompleteControlName).setValue(this.application.documentationComplete);
            if (this.application.funeralParlour.length > 0) {
                const funeralParlourControl = this.detailsForm.get(this.funeralParlourFormControlName);
                const funeralParlour = this.application.funeralParlour[0];
                this.recipientSelectService.setRecipient(funeralParlour, false, funeralParlourControl);
            }
            this.applicationTypes.forEach(item => {
                if (item.value === this.application.type) {
                    this.detailsForm.get(this.burialTypeFormControlName).setValue(item);
                }
            });
            let cemetery = this.defaultCemetery;
            this.cemeteries.forEach(item => {
                if (item.cemeteryId === this.application.cemeteryId) {
                    cemetery = item;
                }
            });
            this.detailsForm.get(this.cemeteryFormControlName).setValue(cemetery);
            this.detailsForm.get("description").disable();
            this.detailsForm.get("referenceNumber").disable();
            this.detailsForm.get("pauperDecision").disable();
            this.detailsForm.get("isDocumentationComplete").disable();
            this.changeDetectorRefs.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: SettingsService },
        { type: MapService },
        { type: MapServiceService },
        { type: GraveSearchService },
        { type: ViewApplicationService },
        { type: RecipientSelectService },
        { type: AppControllerService },
        { type: RequestStatusService },
        { type: CemeteryService },
        { type: DatePipe },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsCmComponent = __decorate([
    Component({
        selector: "app-view-application-details-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsCmComponent);
export { ViewApplicationDetailsCmComponent };
